import { DatabaseServiceType } from 'customers/tenants-common-view/lib/schema/DatabaseService.types';

export const isMultiAZ = (database: DatabaseServiceType): boolean => {
  const instances = database?.instances;

  const dcNodes = instances?.filter((instance) => instance?.type === 'DC');

  return dcNodes?.length > 1;
};
